module.exports = __webpack_public_path__ + "assets/img/1081587020803_.pic_hd.916be648.jpg";